// import { ComingSoon } from './pages';
import { /*SignIn, Home,*/ ComingSoon } from './pages';

export default [
  // { exact: true, path: '/sign-in', component: SignIn, public: true },
  // { exact: true, path: '/', component: Home },
  { exact: true, path: '/', component: ComingSoon },
];
